import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { colors } from "@/theme/colors";

export type CustomerType = "INSTITUTION" | "COMPANY" | "INDIVIDUAL";

export interface CustomerTypeBadgeProps extends Omit<
  ChipProps,
  "label" | "color"
> {
  type: CustomerType;
}

const typeConfig: Record<
  CustomerType,
  { label: string; bg: string; text: string }
> = {
  INSTITUTION: {
    label: "Institution",
    bg: colors.customerType.institution.bg,
    text: colors.customerType.institution.text,
  },
  COMPANY: {
    label: "Entreprise",
    bg: colors.customerType.company.bg,
    text: colors.customerType.company.text,
  },
  INDIVIDUAL: {
    label: "Particulier",
    bg: colors.customerType.individual.bg,
    text: colors.customerType.individual.text,
  },
};

/**
 * Composant CustomerTypeBadge pour afficher le type de client
 *
 * @example
 * ```tsx
 * <CustomerTypeBadge type="INSTITUTION" />
 * <CustomerTypeBadge type="INDIVIDUAL" />
 * ```
 */
export const CustomerTypeBadge: React.FC<CustomerTypeBadgeProps> = ({
  type,
  sx,
  ...props
}) => {
  const config = typeConfig[type];

  return (
    <Chip
      label={config.label}
      sx={{
        bgcolor: config.bg,
        color: config.text,
        borderRadius: 1, // rounded
        fontSize: "10px",
        fontWeight: 500,
        height: "auto",
        py: 0.25,
        "& .MuiChip-label": {
          px: 1,
        },
        ...sx,
      }}
      {...props}
    />
  );
};
